import { Component, Inject, OnInit } from '@angular/core';
import { WIZY_DIALOG_DATA, WizyDialogRef } from 'src/app/modules/shared/design-system/modal';
import { ConfirmationOptions } from './confirmationOptions.model';

@Component({
    selector: 'lib-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
    /**
     * Sécurité pour la confirmation
     */
    enableConfirm: boolean;

    constructor(
        public dialogRef: WizyDialogRef<ConfirmDialogComponent>,
        @Inject(WIZY_DIALOG_DATA) public data: ConfirmationOptions,
    ) {}

    ngOnInit() {
        // S'il y a une case à cocher, alors empêche la confirmation par défaut
        this.enableConfirm = !this.data.messageCheckboxConfirm;
    }

    onConfirm(): void {
        // Contrôle de sécurité
        if (!this.enableConfirm) {
            return;
        }
        this.dialogRef.close(true);
    }

    onIgnorer(): void {
        this.dialogRef.close('complete');
    }

    onDismiss(): void {
        this.dialogRef.close(false);
    }
}
